import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import { useTheme } from '@mui/material/styles';
import React, { useContext } from 'react';
import { ManagerConferenceContext } from '@/store';

const useStyles = (theme) => ({
  tagChip: {
    marginRight: '5px !important',
    marginBottom: '5px !important',
    textTransform: 'capitalize !important',
    borderRadius: '15px !important',
  },
  tagChip_skill_dark: {},
  tagChip_scouting_dark: {
    color: `${theme.palette.secondary.light} !important`,
    borderColor: `${theme.palette.secondary.light} !important`,
  },
});

const CoChip = (props) => {
  const { conferenceData } = useContext(ManagerConferenceContext) ?? {};
  const conference = conferenceData?.conference;
  const palette = conference?.theme_live?.palette || {};

  const theme = useTheme();
  const classes = useStyles(theme);
  const tagChipColor = !props.selected
    ? classes[`tagChip_${props.tagtype}_dark`]
    : '';
  const color = {
    skill: palette.primary || theme.palette.primary.main,
    scouting: palette.secondary || theme.palette.secondary.main,
  };
  
  const chipColor = color[props.tagtype];

  return (
    <Chip
      {...props}
      variant={props.selected ? 'filled' : 'outlined'}
      sx={{
        '& .MuiChip-deleteIcon': {
          '&:hover': { color: '#000' },
        },
        ...classes.tagChip,
        ...tagChipColor,
        color: props.selected ? '#fff' : chipColor,
        borderColor: chipColor,
        backgroundColor: props.selected ? chipColor : 'transparent',
      }}
      avatar={props.count === undefined ? null : <Avatar>{props.count}</Avatar>}
    />
  );
};

export default CoChip;
